/* eslint-disable no-param-reassign */
/* eslint-disable prefer-template */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Col,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import ModalV2 from 'components/ModalV2';
import ScrollableItemsList from './ScrollableItemsList';
/* eslint-enable no-unused-vars */

class MTableActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      currentAction: null,
      dropdownOpen: false,
    };
  }

  handleModalToggle = () => {
    this.setState(prevState => ({ showModal: !prevState.showModal }));
  };

  handleModalConfirm = () => {
    const { currentAction } = this.state;
    if (currentAction && currentAction.onClick) {
      currentAction.onClick(null, this.props.data);
    }
    this.setState({ showModal: false, currentAction: null });
  };

  handleModalCancel = () => {
    this.setState({ showModal: false, currentAction: null });
  };

  toggleDropdown = () => {
    this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }));
  };

  handleActionClick = (action, event) => {
    if (action.onClick) {
      if (action.modal) {
        this.setState({ showModal: true, currentAction: action });
      } else {
        action.onClick(event, this.props.data);
      }
      event.stopPropagation();
    }
  };

  renderModalContent = modalMessage => {
    const content = [];
    const { data } = this.props;
    const selectedItemsLines = data.map(x => x.title);
    content.push(modalMessage);
    // Handle case where selected items are at the end
    if (selectedItemsLines.length > 0) {
      content.push(
        <ScrollableItemsList
          key="selected-items-container-end"
          items={selectedItemsLines}
        />
      );
    }

    return content;
  };

  renderButton(action, index) {
    if (typeof action === 'function') {
      action = action(this.props.data);
      if (!action) {
        return null;
      }
    }
    if (action.toobarHide && action.toobarHide(this.props.data)) {
      return null;
    }

    const actionIcon = action.toolbarIcon || action.icon;

    const actionButton = (
      <Button
        key={action.icon + '' + index}
        disabled={action.disabled}
        className={classnames(action.toolbarClassName)}
        color={action.toolbarButtonPriority}
        onClick={event => this.handleActionClick(action, event)}
      >
        {action.title || action.tooltip} <FontAwesomeIcon icon={actionIcon} />
      </Button>
    );
    return actionButton;
  }

  renderDropdownItem(action, index) {
    if (typeof action === 'function') {
      action = action(this.props.data);
      if (!action) {
        return null;
      }
    }
    if (action.toobarHide && action.toobarHide(this.props.data)) {
      return null;
    }

    const actionIcon = action.toolbarIcon || action.icon;

    return (
      <DropdownItem
        key={action.icon + '' + index}
        disabled={action.disabled}
        onClick={event => this.handleActionClick(action, event)}
      >
        <FontAwesomeIcon icon={actionIcon} className="me-2 pr-1" />
        {action.title || action.tooltip}
      </DropdownItem>
    );
  }

  render() {
    const { showModal, currentAction, dropdownOpen } = this.state;
    const { actions } = this.props;

    if (!actions || actions.length === 0) {
      return null;
    }

    // Filter out hidden actions to get the actual count
    const visibleActions = actions.filter(action => {
      let actionObj = action;
      if (typeof action === 'function') {
        actionObj = action(this.props.data);
        if (!actionObj) {
          return false;
        }
      }
      return !(actionObj.toobarHide && actionObj.toobarHide(this.props.data));
    });

    if (visibleActions.length === 0) {
      return null;
    }

    // If multiple actions, render as dropdown
    const selectActions = visibleActions.filter(x => x.isSelectedAction);
    const freeActions = visibleActions.filter(x => x.isFreeAction);
    return (
      <React.Fragment>
        <span className="flex" style={{ gap: '5px' }}>
          {selectActions.length === 1 &&
            this.renderButton(selectActions[0], freeActions.length)}

          {selectActions.length > 1 && (
            <Dropdown isOpen={dropdownOpen} toggle={this.toggleDropdown}>
              <DropdownToggle caret color="primary">
                Actions
              </DropdownToggle>
              <DropdownMenu>
                {selectActions.map((action, index) =>
                  this.renderDropdownItem(action, index)
                )}
              </DropdownMenu>
            </Dropdown>
          )}
          {freeActions.map((x, i) => this.renderButton(x, i))}
        </span>
        <ModalV2
          show={showModal}
          handleToggle={this.handleModalToggle}
          title="Confirm Action"
          hideButton
          handleConfirm={this.handleModalConfirm}
          confirmText={currentAction && currentAction.modalConfirmButtonText}
          confirmClassname={currentAction && currentAction.modalStyle}
          footer={<p>No, let me edit my selection</p>}
        >
          <div>
            {currentAction &&
              currentAction.modalMessage &&
              this.renderModalContent(currentAction.modalMessage)}
          </div>
        </ModalV2>
      </React.Fragment>
    );
  }
}

MTableActions.defaultProps = {
  actions: [],
  data: {},
};

MTableActions.propTypes = {
  actions: PropTypes.array.isRequired,
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ]),
};

export default MTableActions;
/* eslint-enable prefer-template */
/* eslint-enable react/destructuring-assignment */
/* eslint-enable react/default-props-match-prop-types */
/* eslint-enable react/forbid-prop-types */
/* eslint-enable react/require-default-props */
/* eslint-enable no-param-reassign */
